import { InjectionToken } from '@angular/core';
import { Category } from '.';
import { Observable } from 'rxjs';
import { DocumentFilterItem } from './document-filter-item';

export interface FilterItemsLoader {
    loadFilterItemsByCategory(category: Category, sponsorIdFilter: Observable<string>): Observable<DocumentFilterItem[]>;
}

export const FILTER_ITEM_LOADER = new InjectionToken<FilterItemsLoader>('FilterItemsLoaderForFilteredGrid');
